import { render, staticRenderFns } from "./IconBubbleSpanish.vue?vue&type=template&id=f760e0a6&"
import script from "./IconBubbleSpanish.vue?vue&type=script&lang=js&"
export * from "./IconBubbleSpanish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports